import ConfirmModal from 'components/Modal/ConfirmModal'
import { useState } from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import RewardModal from 'components/Modal/RewardModal'
import { getUserQuery, useAddReward } from 'dataLayer/user'
import { getUserinfo } from 'utils/localStorage'
import LoginWebModal from 'components/Modal/LoginWebModal'
import { useQuery } from 'react-query'
import { useDispatch } from 'react-redux'
import { reloadHeader, showSnackbar } from 'store/actions'
import { Link } from 'react-router-dom'
import WarningModal from 'components/Modal/WarningModal'

function PrizeCard({ data }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const [modalConfirm, setModalConfirm] = useState(false)
	const [modalWarning, setModalWarning] = useState(false)
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
	// const [rewardModal, setRewardModal] = useState(false)
	// const [quantityGold, setQuantityGold] = useState(false)
	const [dataSelect, setDataSelect] = useState({})
	// const [errorMultiples, setErrorMultiples] = useState('')

	const { data: user } = useQuery(getUserQuery())
	function openConfirmModal(item) {
		if (getUserinfo()) {
			setDataSelect(item)
			// setRewardModal(true)
			setModalConfirm(true)
		} else {
			// openLoginModal()
		}
	}
	// const [modalShowLoginPass, setModalShowLoginPass] = useState(false)
	// function openLoginModal() {
	// 	setModalShowLoginPass(true)
	// }
	const {
		mutate,
		data: dataAddReward,
		isLoading,
	} = useAddReward(
		result => {
			// setRewardModal(false)
			// setQuantityGold('')
			// setErrorMultiples('')
			setModalConfirm(false)
			dispatch(reloadHeader(new Date() * 1 + 1))
			dispatch(showSnackbar(true, t('modal.success'), 'success'))
		},
		error => {
			dispatch(showSnackbar(true, error?.message || t('modal.error'), 'error'))
		},
	)
	function closeConfirmModal() {
		// setRewardModal(false)
		// setQuantityGold('')
		// setErrorMultiples('')
		setModalConfirm(false)
	}
	const handleAddReward = () => {
		// let checkGold = quantityGold % dataSelect.coin
		// if (checkGold > 0) {
		// 	let textError = t('modal.reward.require_input').replace(
		// 		'[number]',
		// 		dataSelect.coin,
		// 	)
		// 	setErrorMultiples(textError.replace(')', '').replace('(', ''))
		// } else if (quantityGold == '') {
		// 	setErrorMultiples(t('modal.reward.error_null_input'))
		// } else {
		// setErrorMultiples('')


		// modal update
		// setModalWarning(true)
		if (isLoading) return;
		mutate({
			service_id: dataSelect?.sub_service_name,
			command: dataSelect?.command,
			coin: dataSelect.coin,
			location: "GOLD_MINER"
		})
	}

	const [rewardTitle, setRewardTitle] = useState(null)
	function handleRewardTitle(title) {
		setRewardTitle(title)
	}
	return (
		<>
			{data
				?.filter(item => item?.status === 1)
				?.map(item => {
					return (
						<div
							className="package mb-0 mb-md-3"
							style={{
								backgroundImage: `url(${item?.image})`,
								backgroundSize: 'cover',
								backgroundRepeat: 'no-repeat',
							}}
							key={item?.id}
						>
							<div>
								<h2 className="text-center">{item?.name}</h2>
								<p className="text-center">
									{t('prizepage.sub_title').replace('_DATA_', item?.name)}
								</p>
							</div>
							{getUserinfo() ? (
								<Button
									onClick={() => {
										openConfirmModal(item)
										handleRewardTitle(item?.name)
									}}
								>
									{t('prizepage.gold').replace(
										'_GOLD_',
										new Intl.NumberFormat('lo').format(item?.coin),
									)}
								</Button>
							) : (
								<Button
									onClick={() => {
										// openConfirmModal(item)
										// handleRewardTitle(item?.name)
									}}
								>
									<Link
										to={`${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`}
									>
										{t('prizepage.gold').replace(
											'_GOLD_',
											new Intl.NumberFormat('lo').format(item?.coin),
										)}
									</Link>
								</Button>
							)}
						</div>
					)
				})}
			{user ? (
				// <RewardModal
				// 	show={rewardModal}
				// 	onHide={closeConfirmModal}
				// 	setQuantityGold={setQuantityGold}
				// 	quantityGold={quantityGold}
				// 	isLoading={isLoading}
				// 	handleAddReward={handleAddReward}
				// 	itemSelect={dataSelect}
				// 	errorMultiples={errorMultiples}
				// 	user={user}
				// />
				<ConfirmModal
					show={modalConfirm}
					onHide={closeConfirmModal}
					title={t('modal.prize.are_you_sure')
						.replace('_GOLD_', dataSelect.coin)
						.replace('_REWARD_', dataSelect.name)}
					onShowOTP={handleAddReward}
					isLoading={isLoading}
				/>

			) : // : modalShowLoginPass ? (
				// 	<LoginWebModal
				// 		modalShowLoginPass={modalShowLoginPass}
				// 		setModalShowLoginPass={setModalShowLoginPass}
				// 	/>
				// )

				null}
			<WarningModal
				show={modalWarning}
				onHide={() => setModalWarning(false)}
			/>
		</>
	)
}

export default PrizeCard
